
<template>
  <div>
    <v-layout row wrap>
      <!-- MODE 1 -->
      <template v-if="mode == 1">
        <v-flex xs12 md2 class="scroll-mode">
          <v-layout column wrap>
            <v-flex class="py-0" v-for="(classModule, ind) in classData.modules" :key="classModule.id" xs12>
              <module-date :current-module="classModule" :module-position="ind" @dayChanged="changeDay" :class-data="classData" :date-ref="controlDataRef[ind]" :comp-allow="allowWeekDay" :show-mode="mode" @dateRefChanged="setDatePosition" @newDateChanged="changeDatePosition" />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md8 class="scroll-mode">
          <calendar-week :interactive="false" :comp-allow="allowWeekDay" :start="baseDate" />
        </v-flex>
        <v-flex xs12 md2 class="scroll-mode">
          <div class="room-select-box elevation-2">
            <v-layout row wrap>
              <v-flex v-for="(classModule, ind) in classData.modules" :key="classModule.id" class="py-0" xs12>
                <module-room :class-data="classData" :rooms="rooms" :module-position="ind" :current-module="classModule" @roomChanged="changeRoom" />
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </template>
      <!-- MODE 2 -->
      <template v-else-if="mode == 2">
        <v-flex xs12 md2 class="scroll-mode">
          <v-layout column wrap>
            <v-flex class="py-0" v-for="(classModule, ind) in classData.modules" :key="classModule.id" xs12>
              <div style="background-color: rgba(0,0,0,.06)" class="mb-3">
                <p class="text-xs-center ma-0 py-1" @click="unreservateModule = classModule; modulePosition = ind+1; unreservateConfirm = true"><strong>MODULO {{ ind+1 }}</strong></p>
                <module-date :current-module="classModule" :module-position="ind" @dayChanged="changeDay" :class-data="classData" :date-ref="controlDataRef[ind]" :comp-allow="allowWeekDay" :show-mode="mode" @dateRefChanged="setDatePosition" @newDateChanged="changeDatePosition" />
                <module-room :class-data="classData" :rooms="rooms" :module-position="ind" :current-module="classData.modules[ind]" @roomChanged="changeRoom" />
                <hr>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md10 class="scroll-mode">
          <calendar-week :interactive="false" :comp-allow="allowWeekDay" :start="baseDate" />
        </v-flex>
      </template>
      <!-- MODE 3 -->
      <template v-else-if="mode == 3">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="module-box elevation-2 mb-3">
                <v-layout row wrap>
                  <v-flex xs1 class="align-table py-0"><strong>MODULO</strong></v-flex>
                  <v-flex xs2 class="align-table py-0"><strong>DATA</strong></v-flex>
                  <v-flex xs2 class="align-table py-0"><strong>SALA</strong></v-flex>
                  <v-flex xs7 class="align-table py-0"><strong>ASSUNTO</strong></v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex xs12 v-for="(classMod, ind) in classData.modules" :key="classMod.id">
              <list-module :class-mod="classMod" :ind="ind" :grids="grids" @moduleChanged="changeModule" />
            </v-flex>
          </v-layout>
        </v-flex>
      </template>
    </v-layout>
    <div class="class-code">
      <h2 class="font-weight-regular">{{ classData.course_code }}{{ classData.unit_code }}{{ classData.code }} - GRADE {{ classData.grid_name }}</h2>
    </div>
    <div class="mode-controls">
      <i class="fas fa-grip-vertical" @click="mode = 2"></i>
      <i class="fas fa-th" @click="mode = 1"></i>
      <i class="fas fa-grip-horizontal" @click="mode = 3; getModules();"></i>
      <i class="fas fa-arrow-down"></i>
      <i class="fas fa-trash-alt" @click="deleteConfirm = true"></i>
    </div>

    <v-dialog v-model="deleteConfirm" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>CONFIRMAÇÃO DE CANCELAMENTO</v-card-title>
        <v-card-text>
          <p class="ma-0"><strong>TURMA: </strong>{{ classData.course_code }}{{ classData.unit_code }}{{ classData.code }}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="deleteConfirm = false">CANCELAR</v-btn>
          <v-btn color="error" text @click="deleteConfirm = false; deleteClass()">CONFIRMAR E DELETAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unreservateConfirm" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>LIMPAR DATA E/OU SALA</v-card-title>
        <v-card-text>
          <p class="ma-0"><strong>MODULO: </strong>{{ modulePosition }}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="unreservateConfirm = false">CANCELAR</v-btn>
          <v-btn color="error" text @click="unreservate(unreservateModule)">CONFIRMAR E LIMPAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ModuleDate from '../../components/ModuleDate'
import ModuleRoom from '../../components/ModuleRoom'
import CalendarWeek from '../../components/CalendarWeek'
import ListModule from '../../components/ListModules'
import moment from 'moment'

export default {
  name: 'classPos',
  components: { ModuleDate, ModuleRoom, CalendarWeek, ListModule },
  props: ['id'],
  data() {
    return {
      classData: {},
      rooms: [],
      controlDataRef: [],
      baseDate: moment().day(5).format('YYYY-MM-DD'),
      mode: 1,
      grids: [],
      deleteConfirm: false,
      unreservateConfirm: false,
      unreservateModule: undefined,
      modulePosition: undefined
    }
  },
  methods: {
    getClass() {
      this.$http.get(`classes/class/${this.id}`).then(data => {
        this.getRooms(data.data.unit_id)
        this.classData = data.data
      }).catch(err => {
        console.log(err)
      })
    },
    getRooms(unit_id) {
      this.$http.get(`classrooms/unit/${unit_id}`).then(data => {
        this.rooms = data.data
      }).catch(err => {
        console.log(err)
      })
    },
    async changeDay(data) {
      const cond = await this.classData.modules[data.modulePosition].days[0].room_id == null
      const days = await [
        moment(data.currentDay).format('YYYY/MM/DD'),
        moment(data.currentDay).add(1, 'days').format('YYYY/MM/DD'),
        moment(data.currentDay).add(2, 'days').format('YYYY/MM/DD')
      ]
      this.$http.post(`days/reservate/${this.classData.modules[data.modulePosition].id}`, { days }).then(data => {
        // console.log(data)
        this.baseDate = days[0]
      }).catch(err => {
        console.log(data) // TRATAR SALA INDISPONIVEL!
      })
    },
    async changeRoom(dataEmit) {
      this.$http.post(`days/room/${dataEmit.currentModule.id}`, {
        room: dataEmit.currentRoom.id
      }).then(data => {
        this.classData.modules[dataEmit.modulePosition].days.forEach(item => {
          item.room_id = dataEmit.currentRoom.id
          item.room_name = dataEmit.currentRoom.classname
        })
        this.baseDate = moment(dataEmit.currentModule.days[0].day)
      }).catch(err => {
        
      })
    },
    setDatePosition(params) {
      this.controlDataRef.push(params.date)
    },
    changeDatePosition(params) {
      if (this.controlDataRef[params.position] != params.date) {
        this.$set(this.controlDataRef, params.position, params.date)
        this.controlDataRef.forEach((item, ind) => {
          if (ind > params.position) {
            this.$set(this.controlDataRef, ind, moment(this.controlDataRef[ind-1]).add(1, 'month').format('YYYY-MM'))
          }
        })
      }
    },
    changeModule(dataEmit) {
      this.$http.post(`/days/module`, {
        moduleId: dataEmit.modId,
        module: dataEmit.currentModule.id
      }).then(data => {
        this.classData.modules[dataEmit.ind].module_id = dataEmit.currentModule.id,
        this.classData.modules[dataEmit.ind].module_name = dataEmit.currentModule.name
      }).catch(err => {

      })
    },
    allowWeekDay(value) {
      return moment(value).day() == 5
    },
    getModules() {
      this.$http.get(`/modules/${this.classData.grid_id}`).then(data => {
        this.grids = data.data
      }).catch(err => {

      })
    },
    deleteClass() {
      this.$http.delete(`/classes/${this.classData.id}`).then(success => {
        this.$router.push({ name: 'dashboard' })
      }).catch(err => {

      })
    },
    unreservate(module) {
      this.$http.put(`/days/unreservate/${module.id}`).then(success => {
        this.unreservateConfirm = false
        window.location.reload()
      }).catch(err => {

      })
    }
  },
  created() {
    this.getClass()
  }
}
</script>

<style scoped>
  .room-select-box {
    background-color: #fff;
  }
  .class-code {
    position: fixed;
    top: 10px;
    left: 25vw;
    width: 50vw;
    z-index: 3;
    color: #fff;
    text-align: center;
  }
  .scroll-mode {
    height: calc(100vh - 140px);
    overflow: auto;
  }
  .mode-controls {
    position: fixed;
    bottom: 4px;
    z-index: 10;
  }
  .mode-controls i {
    color: #fff;
    font-size: 1.2em;
    border: 2px solid #fff;
    padding: 4px;
    width: 30px;
    text-align: center;
    border-radius: 20%;
    margin-right: 6px;
  }
  .mode-controls i:hover {
    cursor: pointer;
    color: black;
    background-color: #fff;
  }
  .module-box {
    border-left: 10px solid #c4161c;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background-color: #fff;
    padding-left: 20px;
    cursor: pointer;
  }
  .align-table {
    display: flex;
    justify-content: center; /* align horizontal */
    align-items: center;
  }
</style>
